export default __webpack_public_path__ + "static/media/main_3_suubalm.23eeb632.png";